<template>
  <div class="dg-module-form" v-if="amReady">
    <div class="title" v-if="formHeader">{{ this.getFormTitle }}</div>
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="19"
            :disabled="defaultUserId"
            :defaultValue="defaultUserId"
            :label_span="24"
            :options="$store.state['user-api'].dropdownListCache['id']"
            :translateLabel='false'
            :translateLabels="false"
            @amUpdated="selectedUserChanged"
            field_mark="required"
            label="Username"
            name="user_id"
            placeholder="Username"
            rules="required"></dg-select-field>
      </el-col>
    </el-row>

    <div v-if="selectedUser">
      <el-row :key="key" v-for="(division, key) in divisionsList">
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :defaultValue="userDivisionsPercents[division.value].percent"
              :editable="editable"
              :field_span="19"
              :label="division.label + ' Percent'"
              :label_span="24"
              :name="division.value"
              :translateLabel='false'
              field_mark="required"
              placeholder="20"
              rules="required"></dg-text-field>
        </el-col>
      </el-row>
    </div>

    <el-row v-if="selectedUser">
      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <label class="error-field-validate-message text-capitalize"
                 v-show="!this.validData">{{
              (requestErrorMessage) ? $ml.get(requestErrorMessage) : $ml.get('fields_do_not_match_the_required_criteria')
            }}</label>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">
          <dg-confirm-button
              :loading="requestOn"
              :onConfirm="moduleDeleteAction"
              :translate="false"
              class="mr-2"
              confirmButtonType="danger"
              fieldSize="mini"
              icon="el-icon-delete"
              popIcon="el-icon-delete"
              text="remove"
              title="sure to removing this record ?"
              type="danger"
              v-if="editMode"></dg-confirm-button>

          <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                     type="warning" v-if="editable && editMode"></dg-button>
          <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                     v-if="!editable && editMode"></dg-button>

          <dg-button :click="createModule" icon="el-icon-refresh" :loading="requestOn" text="Update"
                     :translate="false" :type="actionButtonType" fieldSize="mini" v-if="editable"></dg-button>

          <!--<dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>-->
        </el-col>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import module from './../index.js'

import {notify, notifySuccess, notifyDanger} from '@/system-services/notify.js'

import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import moduleFormProps from '@/modules-config/mixins/moduleFormProps.js';

export default {
  beforeMount() {
    this.getFormData()
  },
  props: {
    defaultUserId: {
      required: false
    },
    afterUpdate: {
      required: false
    }
  },
  data() {
    return {
      module: {...module},
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      requestErrorMessage: null,
      usersList: [],
      selectedUser: false,
      divisionsList: [],
      userDivisionsPercents: {}
    }
  },
  methods: {
    selectedUserChanged(inputField) {
      let val = inputField.field.field_value
      this.selectedUser = false
      this.getUserDivisionsPercents({userId: val}).then((r) => {
        this.userDivisionsPercents = {}
        $vue.nextTick(() => {
          this.userDivisionsPercents = r
          this.selectedUser = val
        })
      })
    },
    getFormData() {
      let promises = []
      //promises.push(this.getEntityDropDownList().then())
      promises.push($store.dispatch('voip-rate-division-api/getDropDownList').then((r) => {
        this.divisionsList = r
      }))
      promises.push(this.getUsersDropDownList({valueKey: 'id'}).then((r) => {
        this.usersList = r
      }))
      Promise.all(promises).then((values) => {
        this.amReady = true
        $vue.nextTick(() => {
          this.bindController()
        })
      })
    },
    ...$mapActions('user-api', {getUsersDropDownList: 'getUsersDropDownList'}),
    ...$mapActions('voip_user_division_profit_percents-api', {
      getEntityDropDownList: 'getDropDownList',
      getUserDivisionsPercents: 'getUserDivisionsPercents',
      updateEntity: 'update',
    }),
    async createModule() {
      this.validateFields().then(async result => {
        if (!result) {
          this.requestErrorMessage = null;
          return
        }

        this.requestOn = true
        let context = this;
        let data = this.dataModel
        this.updateEntity({id: this.selectedUser, data}).then(r => {
          notifySuccess('Updated')
          if (this.afterUpdate) {
            this.afterUpdate()
          }
        }).finally(r => {
          this.requestOn = false
        })

      })
    }
  },
  mixins: [fieldController, moduleForm, moduleFormProps],
}
</script>
